import React, { useState } from "react";
import { ChevronDown, Clock, Sparkles } from "lucide-react";
import { SITE } from "@/constants/testIds";
import { CtaButton } from "@/components/CtaButton";

export const TreatmentCard = ({ t, defaultOpen = false }) => {
    const [open, setOpen] = useState(defaultOpen);
    return (
        <article
            data-testid={SITE.treatmentCard}
            data-slug={t.slug}
            className="group rounded-2xl border border-border/80 bg-white/80 overflow-hidden hover:-translate-y-0.5 transition-transform duration-200 shadow-[0_8px_24px_rgba(30,35,32,0.06)] hover:shadow-[0_14px_36px_rgba(30,35,32,0.10)]"
        >
            <div className="relative h-44 sm:h-52 overflow-hidden bg-sand">
                <img
                    src={t.image}
                    alt={t.name}
                    loading="lazy"
                    className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 inline-flex items-center gap-1 rounded-full bg-cream/90 px-2.5 py-1 text-xs text-moss">
                    <Clock className="h-3 w-3" strokeWidth={1.75} /> {t.duration}
                </span>
            </div>
            <div className="p-5 sm:p-6">
                <div className="flex items-start justify-between gap-3">
                    <h3 className="font-display text-xl text-moss leading-tight">
                        {t.name}
                    </h3>
                    <span className="shrink-0 rounded-full bg-terracotta/10 px-3 py-1 text-xs font-medium text-terracotta">
                        {t.price}
                    </span>
                </div>
                <p className="mt-2 text-sm text-foreground/75 leading-relaxed">
                    {t.short}
                </p>

                {open && (
                    <div className="mt-4 space-y-3 text-sm text-foreground/80">
                        <div>
                            <p className="font-accent text-[0.7rem] text-moss">
                                BENEFITS
                            </p>
                            <ul className="mt-1 space-y-1.5">
                                {t.benefits?.map((b, i) => (
                                    <li key={i} className="flex items-start gap-2">
                                        <Sparkles
                                            className="mt-0.5 h-3.5 w-3.5 text-sage shrink-0"
                                            strokeWidth={1.75}
                                        />
                                        <span>{b}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div>
                            <p className="font-accent text-[0.7rem] text-moss">
                                WHAT TO EXPECT
                            </p>
                            <p className="mt-1 leading-relaxed">{t.what_to_expect}</p>
                        </div>
                    </div>
                )}

                <div className="mt-5 flex items-center justify-between gap-3">
                    <button
                        type="button"
                        onClick={() => setOpen((v) => !v)}
                        data-testid={SITE.treatmentExpand}
                        data-state={open ? "open" : "closed"}
                        className="inline-flex items-center gap-1 text-sm font-medium text-moss hover:text-terracotta"
                    >
                        {open ? "Show less" : "Learn more"}
                        <ChevronDown
                            className={`h-4 w-4 transition-transform ${open ? "rotate-180" : ""}`}
                        />
                    </button>
                    <CtaButton
                        to="/contact"
                        variant="secondary"
                        icon={false}
                        testid={`book-${t.slug}`}
                    >
                        Book
                    </CtaButton>
                </div>
            </div>
        </article>
    );
};

export default TreatmentCard;
